import axios from "axios";

let requestInterceptor: number | null = null;
let responseInterceptor: number | null = null;

export default class AxiosInterceptor {
  public static create(accessToken: string, logout: () => void) {
    if (requestInterceptor) {
      axios.interceptors.request.eject(requestInterceptor);
    }
    console.log("Creating interceptors");

    requestInterceptor = axios.interceptors.request.use(
      // eslint-disable-next-line arrow-body-style
      async (config) => {
        if (config?.headers?.Authorization) {
          return config;
        }
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${accessToken}`;
        return config;
      },
      (error) => {
        Promise.reject(error);
      },
    );

    if (responseInterceptor) {
      axios.interceptors.response.eject(responseInterceptor);
    }

    responseInterceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const url: string = error.response?.config?.url || "";
        if (
          error.response?.status === 401 &&
          !url.startsWith("https://graph.microsoft.com/")
        ) {
          logout();
        }
        return Promise.reject(error);
      },
    );
  }
}
